type Style = {
  fontFamily: string;
  fontStyle: string;
  fontSize: string;
  lineHeight: string;
  fontWeight: number;
  letterSpacing: string | number;
  textTransform?: string;
};

const createStyleString = (style: Style) => {
  return `
      font-family: ${style.fontFamily};
      font-style: ${style.fontStyle};
      font-size: ${style.fontSize};
      line-height: ${style.lineHeight};
      font-weight: ${style.fontWeight};
      letter-spacing: ${style.letterSpacing};
      ${style.textTransform ? `text-transform: ${style.textTransform};` : ''}
    `
    .trim()
    .replace(/\s+/g, ' ');
};

export const fontFamily = 'Gilroy';
export const fontStyle = 'normal';

export const fontSize = {
  xs: '12px',
  sm: '14px',
  base: '16px',
  lg: '18px',
  xl: '20px',
  '2xl': '24px',
  '3xl': '28px',
  '4xl': '32px',
  '5xl': '44px',
  '6xl': '48px',
  '7xl': '56px',
  '8xl': '68px',
  '9xl': '72px',
};

export const lineHeight = {
  xs: '16px',
  sm: '20px',
  base: '24px',
  lg: '28px',
  xl: '32px',
  '2xl': '38px',
  '3xl': '48px',
  '4xl': '56px',
  '5xl': '66px',
  '6xl': '80px',
  '7xl': '84px',
};

export const fontWeight = {
  regular: 400,
  medium: 500,
  semibold: 600,
};

export const letterSpacing = {
  none: 0,
  tight: '0.4px',
  wide: '0.8px',
};

export const TYPO = {
  title1: createStyleString({
    fontSize: fontSize['9xl'],
    lineHeight: lineHeight['7xl'],
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.none,
    fontFamily,
    fontStyle,
  }),
  title2: createStyleString({
    fontSize: fontSize['7xl'],
    lineHeight: lineHeight['5xl'],
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.none,
    fontFamily,
    fontStyle,
  }),
  title3: createStyleString({
    fontSize: fontSize['5xl'],
    lineHeight: lineHeight['3xl'],
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.none,
    fontFamily,
    fontStyle,
  }),
  title4: createStyleString({
    fontSize: fontSize['4xl'],
    lineHeight: lineHeight['2xl'],
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.tight,
    fontFamily,
    fontStyle,
  }),
  title5: createStyleString({
    fontSize: fontSize['3xl'],
    lineHeight: lineHeight.xl,
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.tight,
    fontFamily,
    fontStyle,
  }),
  subtitle1: createStyleString({
    fontSize: fontSize['2xl'],
    lineHeight: lineHeight.lg,
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.tight,
    fontFamily,
    fontStyle,
  }),
  subtitle2: createStyleString({
    fontSize: fontSize.xl,
    lineHeight: lineHeight.base,
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.tight,
    fontFamily,
    fontStyle,
  }),
  body1: createStyleString({
    fontSize: fontSize.lg,
    lineHeight: lineHeight.lg,
    fontWeight: fontWeight.medium,
    letterSpacing: letterSpacing.none,
    fontFamily,
    fontStyle,
  }),
  body1Bold: createStyleString({
    fontSize: fontSize.lg,
    lineHeight: lineHeight.lg,
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.none,
    fontFamily,
    fontStyle,
  }),
  body2: createStyleString({
    fontSize: fontSize.base,
    lineHeight: lineHeight.base,
    fontWeight: fontWeight.medium,
    letterSpacing: letterSpacing.none,
    fontFamily,
    fontStyle,
  }),
  body2Bold: createStyleString({
    fontSize: fontSize.base,
    lineHeight: lineHeight.base,
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.none,
    fontFamily,
    fontStyle,
  }),
  caption1: createStyleString({
    fontSize: fontSize.sm,
    lineHeight: lineHeight.sm,
    fontWeight: fontWeight.medium,
    letterSpacing: letterSpacing.none,
    fontFamily,
    fontStyle,
  }),
  caption1Bold: createStyleString({
    fontSize: fontSize.sm,
    lineHeight: lineHeight.sm,
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.none,
    fontFamily,
    fontStyle,
  }),
  caption2: createStyleString({
    fontSize: fontSize.xs,
    lineHeight: lineHeight.xs,
    fontWeight: fontWeight.medium,
    letterSpacing: letterSpacing.none,
    fontFamily,
    fontStyle,
  }),
  overline1: createStyleString({
    fontSize: fontSize.base,
    lineHeight: lineHeight.sm,
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.wide,
    textTransform: 'uppercase',
    fontFamily,
    fontStyle,
  }),
  overline2: createStyleString({
    fontSize: fontSize.sm,
    lineHeight: lineHeight.xs,
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.wide,
    textTransform: 'uppercase',
    fontFamily,
    fontStyle,
  }),
  nTitle1: createStyleString({
    fontSize: fontSize['8xl'],
    lineHeight: lineHeight['7xl'],
    fontWeight: fontWeight.regular,
    letterSpacing: letterSpacing.none,
    fontFamily,
    fontStyle,
  }),
  nTitle2: createStyleString({
    fontSize: fontSize['6xl'],
    lineHeight: lineHeight['4xl'],
    fontWeight: fontWeight.regular,
    letterSpacing: letterSpacing.none,
    fontFamily,
    fontStyle,
  }),
};
